import React from 'react';
import AppRoot from './AppRoot';
import { AppAuthProvider } from './contexts/AppAuthContext';
import { AppProvider } from './contexts/AppContext';
import { AppThemeProvider } from './contexts/AppThemeContext';

import './utils/api/api';
import './utils/UIConfigs';

function App() {
  document.title = "کاوش | مدیریت حمل و نقل بین المللی";

  return (
    <AppAuthProvider>
      <AppThemeProvider>
        <AppProvider>
          <AppRoot />
        </AppProvider>
      </AppThemeProvider>
    </AppAuthProvider>
  );
}

export default App;
